import { FileText, Shuffle, Copy, Search, Mail, Phone } from 'lucide-react';
import { Reveal } from './Reveal';

const PEOPLE = [
  'Chaque jour, des chauffeurs finissent plus tard.',
  'Des mécaniciens cherchent des informations.',
  'Des répartiteurs courent après des réponses.',
  'Des employés de bureau ressaisissent les mêmes données.',
];
const STEPS = [
  { t: 'Petit à petit, des minutes disparaissent.', s: 'text-2xl sm:text-3xl text-slate-400' },
  { t: 'Puis des heures.', s: 'text-3xl sm:text-5xl text-slate-300' },
  { t: 'Puis des soirées.', s: 'text-4xl sm:text-6xl text-white' },
  { t: 'Puis des moments qui ne reviendront jamais.', s: 'text-4xl sm:text-6xl lg:text-7xl text-amber-400' },
];
const CAUSES = [
  { icon: FileText, t: 'Documents', d: 'Des papiers qui passent de main en main avant d\'arriver au bureau.' },
  { icon: Shuffle, t: 'Information dispersée', d: 'Un peu dans un cahier, un peu dans un texto, un peu dans la tête de quelqu\'un.' },
  { icon: Copy, t: 'Double saisie', d: 'La même information, écrite une fois sur la route, puis retapée au bureau.' },
  { icon: Search, t: 'Recherche', d: 'Le bon document existe. Encore faut-il le retrouver.' },
  { icon: Mail, t: 'Courriels', d: 'Des allers-retours pour confirmer ce qui est déjà su ailleurs.' },
  { icon: Phone, t: 'Téléphones', d: '« Où es-tu rendu ? » « As-tu la facture ? » « C\'était quoi, le numéro ? »' },
];

export const TimeLoss = () => (
  <section className="bg-[#080B13] py-28 md:py-40" data-testid="problem-section">
    <div className="max-w-6xl mx-auto px-6 sm:px-10">
      <div className="max-w-3xl space-y-4 mb-24">
        {PEOPLE.map((p, i) => <Reveal key={i} delay={i * 120} className="text-lg sm:text-xl text-slate-300">{p}</Reveal>)}
      </div>
      <div className="space-y-8 mb-32">
        {STEPS.map((s, i) => (
          <Reveal key={i} className={`font-heading uppercase font-bold tracking-tight leading-none ${s.s}`}>{s.t}</Reveal>
        ))}
      </div>

      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-amber-500 font-semibold mb-3">Le problème</p>
        <h2 className="font-heading text-4xl sm:text-5xl uppercase font-bold tracking-tight text-white mb-14" data-testid="problem-title">Pourquoi perd-on autant de temps ?</h2>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 rounded-2xl overflow-hidden">
        {CAUSES.map(({ icon: Icon, t, d }, i) => (
          <Reveal key={t} delay={i * 80} className="bg-[#0B0F19] p-8 group hover:bg-[#111827] transition-colors duration-300" data-testid={`problem-cause-${i}`}>
            <Icon size={22} className="text-slate-500 group-hover:text-amber-400 transition-colors duration-300 mb-5" />
            <h3 className="text-white text-lg font-semibold mb-2">{t}</h3>
            <p className="text-slate-400 text-sm leading-relaxed">{d}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
